import { redirect } from 'next/navigation';
import { Params } from 'next/dist/shared/lib/router/utils/route-matcher';

export const CategoriesPage = ({ params }: { params: Params }) =>
  redirect(`/shop/${params.stateSlug}/${params.dispensarySlug}#categories`);
